export default __webpack_public_path__ + "static/media/hernan.190a3388.png";